<template>
  <div class="layout--full-page">
    <div
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img
                  src="/logo.png"
                  alt="login"
                  class="mx-auto"
                  width="200px"
                />
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">Login</h4>
                    <p>
                      Selamat datang kembali, silahkan login untuk masuk ke
                      aplikasi antrian online
                    </p>
                  </div>
                  <div>
                    <vs-input
                      name="email"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Email"
                      v-model="auth.email"
                      class="w-full"
                      :danger="error.email.status"
                      :danger-text="error.email.text"
                      v-on:keyup.enter="login"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                    />

                    <vs-input
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Password"
                      v-model="auth.password"
                      class="w-full mt-6"
                      :danger="error.password.status"
                      :danger-text="error.password.text"
                      v-on:keyup.enter="login"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                    />

                    <div class="flex flex-wrap justify-between my-5">
                      <router-link to="/request-reset-password"
                        >Lupa Password ?</router-link
                      >
                    </div>
                    <vs-button to="/register" type="border">Daftar</vs-button>
                    <vs-button class="float-right" @click="login"
                      >Login</vs-button
                    >
                  </div>
                  <!-- <p class="mt-10 mb-5 w-full text-center">
                    atau masuk dengan Sosial Media
                  </p>
                  <button
                    v-google-signin-button="clientId"
                    class="flex items-center w-full justify-center rounded-lg py-4 px-5 bg-white border-solid border-grey border-0 shadow-md cursor-pointer"
                  >
                    <img src="/google.png" alt="google-logo" class="w-5 mr-5" />
                    <div class="text-black opacity-50  text-lg">
                      Masuk dengan Google
                    </div>
                  </button> -->
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <!-- Dialog  -->
    <!-- <vs-prompt @accept="sendReactivation" @close="closeAlert" :active.sync="isAlertShown">
      <div class="con-exemple-prompt">
        <span>Enter the security code</span>
        <vs-input placeholder="Code" vs-placeholder="Code" class="mt-3 w-full" />
      </div>
      <template slot="footer">
        <div class="footer-dialog">
          <vs-button block>Sign In</vs-button>

          <div class="new">
            New Here?
            <a href="#">Create New Account</a>
          </div>
        </div>
      </template>
    </vs-prompt>-->
    <ez-modal :active="isAlertShown" classModal="w-2/3">
      <div slot="header">
        <h3>Aktivasi Gagal</h3>
      </div>
      <div class="p-3">
        <p>
          Tautan aktivasi sudah tidak berlaku, silahkan melakukan aktivasi ulang
          dengan klik
          <a href="/re-activate">disini</a>.
        </p>
      </div>
    </ez-modal>
  </div>
</template>
<script>
import GoogleSignInButton from "vue-google-signin-button-directive";
export default {
  data() {
    return {
      auth: { email: "", password: "", checkbox_remember_me: false },
      error: {
        email: {
          status: false,
          text: ""
        },
        password: {
          status: false,
          text: ""
        },
        username: {
          status: false,
          text: ""
        }
      },
      isAlertShown: false,
      clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID
    };
  },
  beforeRouteEnter(to, from, next) {
    const token = to.query.confirmEmail || "";
    next(vm => {
      vm.activateUser(token);
    });
  },
  methods: {
    login() {
      this.$vs.loading();
      this.$http
        .post("/app/auth/login", this.auth)
        .then(r => {
          let payload = r.data.data.auth;
          this.$store.dispatch("updateUserInfo", payload).then(() => {
            this.$store.dispatch("setAuthToken", r.data.data.token).then(() => {
              this.$store.dispatch("setAuthType", "customer").then(() => {
                this.$router.push({ name: "ambil-antrian" });
              });
            });
          });
        })
        .catch(e => {
          if (e.response.status == 422) {
            let error = e.response.data.data.errors;
            this.setMessageError(error);
          } else {
            alert(e);
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    setMessageError(error) {
      for (var key in error) {
        if (!error.hasOwnProperty(key)) continue;
        let msgs = error[key];
        this.error[key].text = msgs.join(". ");
        this.error[key].status = true;
        this.$vs.notify({
          title: msgs.join(". "),
          color: "danger",
          iconPack: "feather",
          icon: "icon-x",
          position: "top-right"
        });
      }
    },
    removeMessageError(val = null) {
      if (val) {
        this.error[val].status = false;
        this.error[val].text = "";
      } else {
        for (var key in this.error) {
          this.error[key].status = false;
          this.error[key].text = "";
        }
      }
    },
    activateUser(token) {
      if (token) {
        this.$vs.loading();
        this.$http
          .post(`/app/auth/confirm/${token}`)
          .then(() => {
          })
          .catch(e => {
            if (e.response.status == 400) {
              this.isAlertShown = true;
            }
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      }
    },
    closeAlert() {
      this.isAlertShown = false;
    },
    sendReactivation() {},
    OnGoogleAuthSuccess(idToken) {
      this.$vs.loading();
      this.$http
        .post("/app/auth/google", { token: idToken })
        .then(r => {
          let payload = r.data.data.auth;
          this.$store.dispatch("updateUserInfo", payload).then(() => {
            this.$store.dispatch("setAuthToken", r.data.data.token).then(() => {
              this.$store.dispatch("setAuthType", "customer").then(() => {
                this.$router.push({ name: "ambil-antrian" });
              });
            });
          });
        })
        .catch(e => {
          if (e.response.status == 422) {
            let error = e.response.data.data.errors;
            this.setMessageError(error);
          } else {
            alert(e);
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    OnGoogleAuthFail(error) {
      if (error && error.error != 'popup_closed_by_user') {
        alert(error.error);
      }
    }
  },
  watch: {
    auth: {
      handler() {
        this.removeMessageError();
      },
      deep: true
    }
  },
  directives: {
    GoogleSignInButton
  }
};
</script>
<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
